import React from "react";
import HistorialCambios from "../../../components/HistorialCambios";

const HistorialAlumnos = () => (
  <HistorialCambios
    endpoint="/api/alumnos/historial"
    titulo="Historial de cambios — Alumnos"
    entidadLabel="Alumno"
    volverA="/admin/alumnos"
    sugerenciasEndpoint="/api/alumnos"
    sugerenciasCampo="nombre"
  />
);

export default HistorialAlumnos;
